/** @jsx createElement */
// SVG
import { Card } from '../svg/card';
import { Person } from '../svg/person';
// Other
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import { activate, deactivate, shimmer, activateShimmer } from '../helpers';
import { AnimatedSlide } from '../animated-slide';
import { PlayerTextBlock } from '../players/text-block';

@observer
export class Slide09 extends AnimatedSlide {
  // Animation players
  players = {
    request: null,
    client: null,
  };

  // Run the first animation
  componentDidMount() {
    const { request, client } = this.players;

    this.steps = [
      () => {
        this.animateProgress(3000);
      },
      () => {},
    ];

    this.animations = [
      //
      // Step 1
      //
      [
        {
          targets: client,
          opacity: 1,
          duration: 200,
          delay: 0,
          begin: activateShimmer,
        },
        {
          targets: request,
          opacity: 1,
          duration: 200,
          delay: 1000,
          begin: activateShimmer,
        },
      ],
    ];

    // Play the first animation
    this.play();
  }

  render() {
    const { children, className = '' } = this.props;

    return (
      <div className={`slide-09 ${className}`}>
        {children}
        <div className="content">
          {/* request */}
          <div
            className="player request"
            data-active="0"
            ref={node => (this.players.request = node)}
          >
            <PlayerTextBlock
              title={'Incoming request'}
              width={'250px'}
              showDots={true}
              className={''}
              sections={[
                {
                  title: ['ADDITIONAL INFORMATION'],
                },
              ]}
            />
          </div>

          {/* Client */}
          <div
            className="player client"
            data-active="0"
            ref={node => (this.players.client = node)}
          >
            <Card IconComponent={Person} IconSize={60} text={'ESCALATOR'} />
          </div>
        </div>
      </div>
    );
  }
}
